const updateAvatar = avatar =>{

    return {
        type: "UPDATE_AVATAR",
        playload: avatar
    }
}

export default updateAvatar;